// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";
import { maybe } from "@altostra/type-validations";

export const isMessageActivityLog = objectOf({
  type: number,
  id: string,
  time: number,
  string: string,
  channel: maybe(string, true),
  channel_type: maybe(string, true),
  mc_id: maybe(string, true),
  // non-shared fields
  user_id: maybe(string, true),
  app_name: maybe(string, true),
  individual_errors: maybe(arrayOf(string)),
  messages_json: maybe(string),
  email: maybe(string),
  user_exists: maybe(boolean),
  url: maybe(string),
  response_body: maybe(string, true),
  campaign_id: maybe(string, true),
  link: maybe(string, true),
  phone_number: maybe(string),
  agent_definition_id: maybe(string, true),
  agent_invocation_log_id: maybe(string, true),
  agent_name: maybe(string, true),
});

export const isAppSettingsMessageActivityMessagesResult = objectOf({
  results: arrayOf(isMessageActivityLog),
  hits: number,
});
